import React from "react"

import "./Header.css";
import { AppHeader } from '@nike/eds'
import { useOktaAuth } from '@okta/okta-react'
import { Text, Spinner } from '@nike/eds'
import { useUserDetails, UserAvatar } from '@nike/cch-shared-ui-lib';

function Header() {
    const { oktaAuth } = useOktaAuth();

    const handleSignOut = async () => {
        try {
            await oktaAuth.signOut({ postLogoutRedirectUri: window.location.origin });
        } catch (error) {
            console.error("Sign out failed", error);
        }
    };

    const { user, loading, saveSelectedTerritories } = useUserDetails({
        graphqlEndpoint: process.env.REACT_APP_APPSYNC_CCH_USERINFO_HTTP_ENDPOINT,
        getAccessToken: () => oktaAuth.getAccessToken(),
    });


    function getUserAvatar() {
        if (loading) return <Spinner />;
        return <UserAvatar
            userName={user?.name || ''}
            size={36}
            avatarUrl={user?.avatarUrl}
            email={user?.email}
            onSignOut={() =>
                handleSignOut()
            }
            territoryConfig={{
                currentTerritories: user?.territories.selected || [],
                availableTerritories: user?.territories.available || [],
                onTerritoriesChange: saveSelectedTerritories,
            }}
            isDark={false}
        />;
    }

    return (

    <AppHeader appName={<Text className="app-header-app-name" font="display-4">{"Local Clearance"} </Text>}
               className={"eds-elevation--1"}
               isDark={false}
               avatarSlot={getUserAvatar()}>
    </AppHeader>
    )
}

export default Header;
